module.exports = __webpack_public_path__ + "static/media/LEADWELL.f149e77e.mp4";